// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
    apiKey: "AIzaSyC5kd-kSEiHE1fHBuVxB1Zur0nohEVLaHA",
    authDomain: "hudson-hvac.firebaseapp.com",
    projectId: "hudson-hvac",
    storageBucket: "hudson-hvac.firebasestorage.app",
    messagingSenderId: "17504610001",
    appId: "1:17504610001:web:833b8f738c0bbed1aec7f0",
    measurementId: "G-G5FRHGHMN0"
  };


// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
